/* noop */
"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/lib/patch.prod.js
 ** module id = 4
 ** module chunks = 0
 **/